// extracted by mini-css-extract-plugin
export default {"hyperlink":"EditorExtension_RawHtml_hyperlink__7-XPu"};